// One-time leads consolidation migration
// - Merges `leads`, `waiverLeads`, `waiver_leads`, and controlCenter snapshots
// - Dedupes by (email || phone || id || JSON.stringify(item)).toLowerCase()
// - Writes merged result to `leads`, and mirrors to `waiverLeads` + `waiver_leads`
// - Stores a JSON backup in localStorage under `leads.migration.backup.<ts>`
// - Sets `leads.migrated_v1` flag to avoid rerun

function canonicalKey(item) {
  try {
    const k = (item.email || item.phone || item.id || JSON.stringify(item)).toString();
    return k.toLowerCase();
  } catch (e) {
    return JSON.stringify(item);
  }
}

function readJSON(key) {
  try {
    const v = localStorage.getItem(key);
    if (!v) return [];
    return JSON.parse(v);
  } catch (e) {
    return [];
  }
}

function writeJSON(key, arr) {
  try {
    localStorage.setItem(key, JSON.stringify(arr));
  } catch (e) {
    // ignore quota errors
  }
}

export function migrateLeadsOnce() {
  try {
    if (localStorage.getItem('leads.migrated_v1')) return;

    const sources = [
      'leads',
      'waiverLeads',
      'waiver_leads',
      'controlCenter.v9.2',
      'controlCenter.v5.6',
      'controlCenter.v5.5'
    ];

    const all = [];
    sources.forEach(k => {
      const arr = readJSON(k);
      if (Array.isArray(arr)) arr.forEach(i => all.push(i));
    });

    // dedupe preserving first-seen
    const map = new Map();
    all.forEach(item => {
      const k = canonicalKey(item);
      if (!map.has(k)) map.set(k, item);
    });

    const merged = Array.from(map.values());

    // backup previous canonical leads
    const ts = new Date().toISOString();
    const backupKey = `leads.migration.backup.${ts}`;
    const prevLeads = readJSON('leads');
    try {
      localStorage.setItem(backupKey, JSON.stringify({
        createdAt: ts,
        sources,
        previousLeads: prevLeads,
        mergedCount: merged.length
      }));
    } catch (e) {
      // ignore
    }

    // write canonical plus mirror legacy keys for compatibility
    writeJSON('leads', merged);
    writeJSON('waiverLeads', merged);
    writeJSON('waiver_leads', merged);

    // mark migrated
    localStorage.setItem('leads.migrated_v1', ts);

    // broadcast events so UI updates
    try {
      window.dispatchEvent(new CustomEvent('leadsUpdated', { detail: { source: 'migration', count: merged.length } }));
      localStorage.setItem('braga_migration_ts', ts);
    } catch (e) {}
  } catch (err) {
    // swallow errors to avoid breaking app start
    // migration is best-effort
    console.warn('leads migration failed', err);
  }
}

export default migrateLeadsOnce;
